import SignupForm from "./misc/components/SignupForm";
const Signup = () => {
  return (
    <section className='w-screen h-screen grid place-content-center overflow-hidden'>
      <SignupForm />
    </section>
  );
};

export default Signup;
